import _ from 'lodash';

export const PlaceStatus = {
  OPEN: _.camelCase('Open'),
  CLOSING_SOON: _.camelCase('Closing Soon'),
  CLOSED: _.camelCase('Closed'),
};

export const DAYS_OF_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
export const CLOSING_SOON_MINUTES = 60;
